module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.97/css/toolsmenu.css"